








































































import { GCoinsToImport } from '@/models/admin-panel';
import { typedStore, Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'ImportGCoinsFromFile',
  data() {
    return {
      file: null as unknown as Blob,
      loader: {
        isRequestPending: false,
      },
    };
  },
  destroyed() {
    this.resetData();
  },
  computed: {
    gCoinsFormFileData(): GCoinsToImport[] {
      return typedStore(this).state.gCoins.gCoinsToImport;
    },
    rowsWithValidationErrors(): any[] {
      return this.gCoinsFormFileData.filter(e => e.hasError === true);
    },
    gCoinsTableData(): any {
      const items =  this.gCoinsFormFileData.map(e => {
          return {
            isActive: true,
            row:  e.rowNumber,
            userName: e.userName,
            GCoins: e.amount,
            reason: e.reason,
          };
        },
      );
      return items;
    },
    isFileExtensionValid(): boolean {
      return (this.file as any)?.name.split('.').pop().toLowerCase() === 'csv';
    },
    isFileValid(): boolean {
      return !!this.file && this.isFileExtensionValid && !this.rowsWithValidationErrors.length;
    },
  },
  methods: {
    readFile() {
      return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      setTimeout(() => reader.readAsText(this.file));
      });
    },
    async handleData() {
      if (!this.file || !this.isFileExtensionValid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        const fileData = { csvData: await this.readFile() };
        await this.$store.dispatch(Actions.gCoins.handleGCoinsToImportData, fileData);
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    resetData() {
      this.file = null as unknown as Blob;
      this.$store.dispatch(Actions.gCoins.resetGCoinsToImportData);
    },
    async sendData() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.sendGCoinsToImportData, { data: this.gCoinsFormFileData });

        const toastText = this.$t('admin-panel.gcoins.tabs.add.import.toast') as string;
        ToastsService.success(toastText);
        this.resetData();
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
  watch: {
    'loader.isRequestPending': {
      handler(this: any) {
        this.$emit('changeLoaderStatus', this.loader.isRequestPending);
      },
    },
  },
});
